import { Pipe, PipeTransform } from '@angular/core';
import { FUEL_TYPES } from '../lib/fuel-types';

@Pipe({ name: 'fuelType' })
export class FuelTypePipe implements PipeTransform {
  public transform(abbr) {
    return FUEL_TYPES[abbr];
  }
}
